import {apiConstants, config, downloadBlob, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

const buildQueryString = (parameters: Record<string, unknown>) => {
    const entries = Object.entries(parameters)
        .filter(([, value]) => value !== undefined && value !== null && typeof value !== "function")
        .map(([key, value]) => [key, String(value)]);

    return new URLSearchParams(entries).toString();
}

class serverOwnLoanHistoryApi {

    static getOwnLoanHistory(loanHistorySearchCriteria: Record<string, unknown>) {
        const queryParameters = buildQueryString(loanHistorySearchCriteria);
        return sendRequest(
            requestOptions(`${config.URL}own/loan/history?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }

    static getDropdownListsForOwnLoanSearch()
    {
        const isForLoanManagementValue = false;
        const queryParameters = new URLSearchParams({isForLoanManagementValue: String(isForLoanManagementValue)}).toString();
        return sendRequest(
            requestOptions(config.URL + `own/loan/dropdown-lists?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static getOwnLoanHistoryReport(ownLoanHistorySearchCriteria: Record<string, unknown>) {
        const params = {
            ...ownLoanHistorySearchCriteria,
        };
        const queryParameters = buildQueryString(params);
        return downloadBlob(
            requestOptions(config.URL + `own/reports/loan-history/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            ),
        );
    }
}

export const ownLoanHistoryApi = config.environment.MODE === config.modes.SERVER ? serverOwnLoanHistoryApi : serverOwnLoanHistoryApi;
